import type { ProductFamilyId } from "./catalog";

export interface ProductFamilyImage {
  readonly basePath: string;
  readonly width: number;
  readonly height: number;
  readonly objectPosition: string;
}

const wearPlateImage: ProductFamilyImage = {
  basePath: "/assets/images/products/families/wear-plate",
  width: 1536,
  height: 1024,
  objectPosition: "50% 54%",
};

const structuralSteelImage: ProductFamilyImage = {
  basePath: "/assets/images/products/families/structural-steel",
  width: 1536,
  height: 1024,
  objectPosition: "50% 52%",
};

const armourSteelImage: ProductFamilyImage = {
  basePath: "/assets/images/products/families/armour-steel",
  width: 1536,
  height: 1024,
  objectPosition: "58% 52%",
};

export const productFamilyImages: Readonly<
  Record<ProductFamilyId, ProductFamilyImage>
> = {
  "bisalloy-wear": wearPlateImage,
  "bisalloy-structural": structuralSteelImage,
  "bisalloy-armour": armourSteelImage,
  "bisalloy-protection": {
    basePath: "/assets/images/products/families/protection-steel",
    width: 1536,
    height: 1024,
    objectPosition: "46% 50%",
  },
  "other-high-strength": structuralSteelImage,
};

export function getProductFamilyImage(familyId: ProductFamilyId) {
  return productFamilyImages[familyId];
}
